import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Alexa Kreizinger --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Null destination plugin (Telemetry Pipeline)";
const frontMatter = {
  "title": "Null destination plugin (Telemetry Pipeline)",
  "description": "Use the null destination plugin."
};
import {Icon} from '@/components';
import {mdiCheckCircle, mdiCancel} from '@mdi/js';
import PipelineFlow, {useTOC as useTOC0} from '@/_partials/pipeline-flow-destination.mdx';
export function useTOC(props) {
  return [...useTOC0(), {
    value: "Supported telemetry types",
    id: "supported-telemetry-types",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    h1: "h1",
    h2: "h2",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"Null destination plugin"}</_components.h1>{"\n"}<PipelineFlow />{"\n"}<_components.p>{"Null is a type of data destination that lets you discard your telemetry data without\nwriting it to any external storage or output destination. The Null destination plugin\nin Chronosphere Telemetry Pipeline is a tool for testing or debugging purposes when\nyou want to simulate a data flow without actually writing data to disk or sending it\nto an external system."}</_components.p>{"\n"}<_components.p>{"With the Null destination plugin, you can configure your pipeline to discard any\ntelemetry data that passes through it, ensuring that the data isn’t saved or\ntransmitted to any external system. This can be used for verifying the configuration\nof your pipeline or for troubleshooting issues in your data processing workflow. The\nNull destination plugin can help you avoid unnecessary data storage or network\ntraffic."}</_components.p>{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.p>{"This plugin supports these telemetry types:"}</_components.p>{"\n"}<_components.table><_components.thead><_components.tr><_components.th style={{
    textAlign: "center"
  }}>{"Logs"}</_components.th><_components.th style={{
    textAlign: "center"
  }}>{"Metrics"}</_components.th><_components.th style={{
    textAlign: "center"
  }}>{"Traces"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td style={{
    textAlign: "center"
  }}><Icon path={mdiCheckCircle} style={{
    color: 'rgb(89, 204, 141)'
  }} aria-label={"Yes"} /></_components.td><_components.td style={{
    textAlign: "center"
  }}><Icon path={mdiCheckCircle} style={{
    color: 'rgb(89, 204, 141)'
  }} aria-label={"Yes"} /></_components.td><_components.td style={{
    textAlign: "center"
  }}><Icon path={mdiCheckCircle} style={{
    color: 'rgb(89, 204, 141)'
  }} aria-label={"Yes"} /></_components.td></_components.tr></_components.tbody></_components.table></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/pipeline-data/plugins/destination-plugins/null',
  {"filePath":"pages/pipeline-data/plugins/destination-plugins/null.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)